import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refreshAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const code = searchParams.get("code");

        if (!code) {
          console.error("No authorization code in callback");
          navigate("/auth");
          return;
        }

        // Use the same redirect_uri the backend used for Google
        const redirectUri = `${window.location.origin}/auth/google/callback`;

        await axios.post(`${API}/auth/session`, {
          code,
          redirect_uri: redirectUri,
        });

        await refreshAuth();

        // Navigate based on role
        const meRes = await axios.get(`${API}/auth/me`, { withCredentials: true });
        const role = meRes.data?.role;
        if (role === "admin") navigate("/admin", { replace: true });
        else if (role === "ca") navigate("/ca/dashboard", { replace: true });
        else if (meRes.data?.has_company) navigate("/dashboard", { replace: true });
        else navigate("/company/setup", { replace: true });
      } catch (error) {
        console.error("Google OAuth callback error:", error);
        navigate("/auth");
      }
    };

    processAuth();
  }, []);

  return (
    <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#2563EB] mx-auto mb-4" />
        <p className="text-[#6B7280]">Completing sign in...</p>
      </div>
    </div>
  );
}
